import { Card } from 'react-bootstrap';
import Badge from 'react-bootstrap/Badge';
import '../index.scss';
import React, { useEffect, useState } from 'react';
import Skeleton from './skeleton/GenericSkeleton';
import { useSelector } from 'react-redux';
import httpheader from 'src/Admin/shared/httpheader';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

const CopaymentNetwork = (CopaymentData) => {
  const cName = httpheader.getCNAME();
  const { Value_Network_For_Coverage_Admin } =
    useSelector((state) => state.app.appConfigs.Network_Setting) || 'network';
  const { CoveredSer_Plans } =
    useSelector((state) => state.app?.appConfigs) || {};
  const [showCustomMessage, setShowCustomMessage] = useState(false);
  let accumsLabel = '';
  if (CopaymentData?.label) {
    accumsLabel = CopaymentData?.label;
  } else {
    if (CopaymentData?.network === 'In Network') {
      if (CopaymentData?.networkProps.label) {
        if (CopaymentData?.networkProps.label !== 'ALL') {
          accumsLabel = CopaymentData?.networkProps.label;
        } else {
          accumsLabel = 'In-network ';
        }
      } else {
        accumsLabel = 'In-network ';
      }
    }
    if (CopaymentData?.network === 'Out of Network') {
      if (Value_Network_For_Coverage_Admin === 'tier') {
        let networkTier = '';
        CopaymentData.networkPlandetails &&
          CopaymentData.networkPlandetails.map((data) => {
            if (data.BenefitScheduleType === 'Out-Of-Area') {
              networkTier = data.NetworkTier;
            }
          });
        if (networkTier) {
          accumsLabel = networkTier;
        } else {
          accumsLabel = 'Out-of-network';
        }
      } else {
        accumsLabel = 'Out-of-network';
      }
    }
    if (CopaymentData?.network === 'Penalty') {
      if (Value_Network_For_Coverage_Admin === 'tier') {
        let networkTier = '';
        CopaymentData.networkPlandetails &&
          CopaymentData.networkPlandetails.map((data) => {
            if (data.BenefitScheduleType === 'Penalty') {
              networkTier = data.NetworkTier;
            }
          });
        if (networkTier) {
          accumsLabel = networkTier;
        } else {
          accumsLabel = 'Out-of-network Penalty';
        }
      } else {
        accumsLabel = 'Out-of-network Penalty';
      }
    }
  }

  useEffect(() => {
    if (
      (cName.includes('keenan') || cName.includes('tpabenefits')) &&
      CoveredSer_Plans !== undefined &&
      CoveredSer_Plans?.length
    ) {
      if (CoveredSer_Plans.includes(CopaymentData?.BenefitPlan)) {
        setShowCustomMessage(true);
      }
    }
  }, [CopaymentData?.BenefitPlan]);

  return CopaymentData?.isAPIFailed ? (
    CopaymentData?.isNotFound ? (
      <Card>
        <Card.Header>
          <h5>{accumsLabel}</h5>
        </Card.Header>
        <Card.Body>
          <Card.Text>Copay Details Not Available</Card.Text>
        </Card.Body>
      </Card>
    ) : (
      <Card>
        <Card.Header>
          <h5>{accumsLabel}</h5>
        </Card.Header>
        <Card.Body>
          <Card.Text>Unable to retrieve details</Card.Text>
        </Card.Body>
      </Card>
    )
  ) : CopaymentData?.dataFetching ||
    CopaymentData?.NetworkExclusionFlag === undefined ? (
    <Skeleton />
  ) : (
    <>
      {CopaymentData?.NetworkExclusionFlag === false ? (
        <Card>
          <Card.Header>
            <h5>{accumsLabel}</h5>
          </Card.Header>
          <Card.Body>
            {/*{(CopaymentData?.coverageCopayments?.coPaymentExists=== false && ( CopaymentData?.coverageCopayments?.preCertification !=='Y'  && CopaymentData?.coverageCopayments?.deductiableIsWaivedOff===false  && CopaymentData?.coverageCopayments?.coInsurancePercentage =='NA' && CopaymentData?.coverageCopayments?.lifeTimeMaxAmount =='NA'&& CopaymentData?.coverageCopayments?.lifeTimeMaxVisits=='NA'&&
              CopaymentData?.coverageCopayments?.annualMaxAmount =='NA'&& CopaymentData?.coverageCopayments?.annualMaxVisits =='NA' )) && <>
              <Card.Text>Not Applicable, please consult the Benefit Summary document for further information</Card.Text>
              </>} */}
            {CopaymentData?.coverageCopayments?.coPaymentExists === true ? (
              <>
                <>
                  {CopaymentData?.coverageCopayments?.coPaymentAmount !==
                    'NA' ||
                  CopaymentData?.coverageCopayments?.deductiableIsWaivedOff !==
                    'NA' ||
                  CopaymentData?.coverageCopayments?.coInsurancePercentage !==
                    'NA' ? (
                    <>
                      {CopaymentData?.coverageCopayments
                        ?.coInsurancePercentage !== 100 ? (
                        <>
                          {CopaymentData?.coverageCopayments
                            ?.coPaymentAmount !== 'NA' ||
                          CopaymentData?.coverageCopayments
                            ?.deductiableIsWaivedOff !== 'NA' ? (
                            <>
                              {CopaymentData?.coverageCopayments
                                ?.coPaymentAmount !== 'NA' && (
                                <Card.Text>
                                  You Pay{' '}
                                  <b className="co-pay">
                                    {formatter.format(
                                      parseFloat(
                                        CopaymentData?.coverageCopayments
                                          ?.coPaymentAmount,
                                      ).toFixed(2),
                                    )}{' '}
                                    <Badge pill>Copay</Badge>
                                  </b>
                                </Card.Text>
                              )}
                              {CopaymentData?.coverageCopayments
                                ?.coInsurancePercentage !== 'NA' && (
                                <Card.Text>
                                  {CopaymentData?.coverageCopayments
                                    ?.coInsurancePercentage >= 0 && (
                                    <b className="co-pay">
                                      {
                                        CopaymentData?.coverageCopayments
                                          ?.coInsurancePercentage
                                      }
                                      %{' '}
                                    </b>
                                  )}
                                  {CopaymentData?.coverageCopayments
                                    ?.coInsurancePercentage !== 100 && (
                                    <>
                                      {CopaymentData?.coverageCopayments
                                        ?.deductiableIsWaivedOff === false ? (
                                        <span>
                                          Co-Insurance
                                          {/*from your Out of Pocket */}
                                        </span>
                                      ) : (
                                        <span>
                                          Co-Insurance
                                          {/*until from your Out of Pocket */}
                                        </span>
                                      )}
                                    </>
                                  )}
                                </Card.Text>
                              )}
                              {CopaymentData?.coverageCopayments
                                ?.deductiableIsWaivedOff === true && (
                                <Card.Text>Deductible Waived</Card.Text>
                              )}
                              {CopaymentData?.coverageCopayments
                                ?.deductiableIsWaivedOff === false && (
                                <Card.Text>Deductible Applies</Card.Text>
                              )}
                            </>
                          ) : (
                            <>
                              <Card.Text>
                                You Pay{' '}
                                <b className="co-pay">
                                  {
                                    CopaymentData?.coverageCopayments
                                      ?.coInsurancePercentage
                                  }
                                  %{' '}
                                </b>{' '}
                                Co-Insurance from your Out of Pocket max
                              </Card.Text>
                              {CopaymentData?.coverageCopayments
                                ?.deductiableIsWaivedOff === true && (
                                <Card.Text>Deductible Waived</Card.Text>
                              )}
                              {CopaymentData?.coverageCopayments
                                ?.deductiableIsWaivedOff === false && (
                                <Card.Text>Deductible Applies</Card.Text>
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <Card.Text>
                            {' '}
                            You Pay <b className="co-pay">100%</b>
                          </Card.Text>
                          {CopaymentData?.coverageCopayments
                            ?.deductiableIsWaivedOff === true && (
                            <Card.Text>Deductible Waived</Card.Text>
                          )}
                          {CopaymentData?.coverageCopayments
                            ?.deductiableIsWaivedOff === false && (
                            <Card.Text>Deductible Applies</Card.Text>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {
                        <Card.Text>
                          Copay-{' '}
                          {showCustomMessage
                            ? 'Refer to Benefit Documents'
                            : 'N/A'}
                        </Card.Text>
                      }
                    </>
                  )}
                </>
                {CopaymentData?.coverageCopayments?.preCertification ===
                  'Y' && <Card.Text>Precertification Required</Card.Text>}
              </>
            ) : (
              <>
                <Card.Text>
                  Copay-{' '}
                  {showCustomMessage ? 'Refer to Benefit Documents' : 'N/A'}
                </Card.Text>
                {CopaymentData?.coverageCopayments?.coInsurancePercentage !==
                  'NA' && (
                  <Card.Text>
                    <b className="co-pay">
                      {CopaymentData?.coverageCopayments?.coInsurancePercentage}
                      %{' '}
                    </b>{' '}
                    <span>Co-Insurance</span>
                  </Card.Text>
                )}
                {CopaymentData?.coverageCopayments?.deductiableIsWaivedOff ===
                  true && <Card.Text>Deductible Waived</Card.Text>}
                {CopaymentData?.coverageCopayments?.deductiableIsWaivedOff ===
                  false && <Card.Text>Deductible Applies</Card.Text>}
                {CopaymentData?.coverageCopayments?.preCertification ===
                  'Y' && <Card.Text>Precertification Required</Card.Text>}
              </>
            )}

            {CopaymentData?.coverageCopayments?.lifeTimeMaxAmount !== 'NA' ||
            CopaymentData?.coverageCopayments?.lifeTimeMaxVisits !== 'NA' ||
            CopaymentData?.coverageCopayments?.annualMaxAmount !== 'NA' ||
            CopaymentData?.coverageCopayments?.annualMaxVisits !== 'NA' ? (
              <>
                {
                  <>
                    <Card.Text className="benifit-limitations-label">
                      Benefit Limitations:
                    </Card.Text>
                    {(CopaymentData?.coverageCopayments?.annualMaxAmount !==
                      'NA' ||
                      CopaymentData?.coverageCopayments?.annualAccumAmount !==
                        'NA') && (
                      <Card.Text>
                        {CopaymentData?.coverageCopayments?.annualMaxAmount !==
                          'NA' &&
                          CopaymentData?.coverageCopayments?.annualMaxAmount <
                            9999999 && (
                            <span>
                              <b className="co-pay-limit">
                                {formatter.format(
                                  parseFloat(
                                    CopaymentData?.coverageCopayments
                                      ?.annualMaxAmount,
                                  ).toFixed(2),
                                )}
                              </b>
                              &nbsp;&nbsp;
                            </span>
                          )}
                        {(CopaymentData?.coverageCopayments?.annualMaxAmount !==
                          'NA' ||
                          (CopaymentData?.coverageCopayments
                            ?.annualAccumAmount !== 'NA' &&
                            CopaymentData?.coverageCopayments
                              ?.annualAccumAmount > 0)) &&
                          (CopaymentData?.coverageCopayments
                            ?.annualMaxAmount !== 'NA' &&
                          CopaymentData?.coverageCopayments?.annualAccumAmount >
                            CopaymentData?.coverageCopayments
                              ?.annualMaxAmount ? (
                            <p>
                              Annual{' '}
                              <b className="co-pay-limit">(100%&nbsp;Used)</b>
                            </p>
                          ) : (
                            <span>
                              Annual&nbsp;(
                              <b className="co-pay-limit">
                                $
                                {
                                  CopaymentData?.coverageCopayments
                                    ?.annualAccumAmount
                                }
                              </b>
                              &nbsp;Used){' '}
                            </span>
                          ))}
                      </Card.Text>
                    )}
                    {(CopaymentData?.coverageCopayments?.lifeTimeMaxAmount !==
                      'NA' ||
                      CopaymentData?.coverageCopayments?.lifeTimeAccumAmount !==
                        'NA') && (
                      <Card.Text>
                        {CopaymentData?.coverageCopayments
                          ?.lifeTimeMaxAmount !== 'NA' &&
                          CopaymentData?.coverageCopayments?.lifeTimeMaxAmount <
                            9999999 && (
                            <span>
                              <b className="co-pay-limit">
                                {formatter.format(
                                  parseFloat(
                                    CopaymentData?.coverageCopayments
                                      ?.lifeTimeMaxAmount,
                                  ).toFixed(2),
                                )}{' '}
                              </b>
                              &nbsp;
                            </span>
                          )}
                        {(CopaymentData?.coverageCopayments
                          ?.lifeTimeMaxAmount !== 'NA' ||
                          (CopaymentData?.coverageCopayments
                            ?.lifeTimeAccumAmount !== 'NA' &&
                            CopaymentData?.coverageCopayments
                              ?.lifeTimeAccumAmount > 0)) &&
                          (CopaymentData?.coverageCopayments
                            ?.lifeTimeMaxAmount !== 'NA' &&
                          CopaymentData?.coverageCopayments
                            ?.lifeTimeAccumAmount >
                            CopaymentData?.coverageCopayments
                              ?.lifeTimeMaxAmount ? (
                            <p>
                              Lifetime{' '}
                              <b className="co-pay-limit">(100%&nbsp;Used)</b>
                            </p>
                          ) : (
                            <span>
                              Lifetime&nbsp;(
                              <b className="co-pay-limit">
                                $
                                {
                                  CopaymentData?.coverageCopayments
                                    ?.lifeTimeAccumAmount
                                }{' '}
                              </b>
                              &nbsp;Used)
                            </span>
                          ))}
                      </Card.Text>
                    )}
                    {(CopaymentData?.coverageCopayments?.annualMaxVisits !==
                      'NA' ||
                      (CopaymentData?.coverageCopayments?.annualAccumVisits !==
                        'NA' &&
                        CopaymentData?.coverageCopayments?.annualAccumVisits >
                          0)) && (
                      <Card.Text>
                        {CopaymentData?.coverageCopayments?.annualMaxVisits !==
                          'NA' &&
                          CopaymentData?.coverageCopayments?.annualMaxVisits <
                            9999999 && (
                            <span>
                              <b className="co-pay-limit">
                                {
                                  CopaymentData?.coverageCopayments
                                    ?.annualMaxVisits
                                }
                              </b>
                              &nbsp;&nbsp;
                            </span>
                          )}
                        {(CopaymentData?.coverageCopayments?.annualMaxVisits !==
                          'NA' ||
                          (CopaymentData?.coverageCopayments
                            ?.annualAccumVisits !== 'NA' &&
                            CopaymentData?.coverageCopayments
                              ?.annualAccumVisits > 0)) &&
                          (CopaymentData?.coverageCopayments
                            ?.annualAccumVisits !== 'NA' &&
                          CopaymentData?.coverageCopayments?.annualAccumVisits >
                            CopaymentData?.coverageCopayments
                              ?.annualMaxVisits ? (
                            <p>
                              Visits Annual{' '}
                              <b className="co-pay-limit">
                                (100%&nbsp;Visits Used)
                              </b>
                            </p>
                          ) : (
                            <span>
                              Visits Annual&nbsp;(
                              <b className="co-pay-limit">
                                {
                                  CopaymentData?.coverageCopayments
                                    ?.annualAccumVisits
                                }
                              </b>
                              &nbsp;
                              {CopaymentData?.coverageCopayments
                                ?.annualAccumVisits > 1
                                ? 'Visits Used'
                                : 'Visit Used'}
                              )
                            </span>
                          ))}
                      </Card.Text>
                    )}
                    {(CopaymentData?.coverageCopayments?.lifeTimeMaxVisits !==
                      'NA' ||
                      (CopaymentData?.coverageCopayments
                        ?.lifeTimeAccumVisits !== 'NA' &&
                        CopaymentData?.coverageCopayments?.lifeTimeAccumVisits >
                          0)) && (
                      <Card.Text>
                        {CopaymentData?.coverageCopayments
                          ?.lifeTimeMaxVisits !== 'NA' &&
                          CopaymentData?.coverageCopayments?.lifeTimeMaxVisits <
                            9999999 && (
                            <span>
                              <b className="co-pay-limit">
                                {
                                  CopaymentData?.coverageCopayments
                                    ?.lifeTimeMaxVisits
                                }
                              </b>
                              &nbsp;&nbsp;
                            </span>
                          )}
                        {(CopaymentData?.coverageCopayments
                          ?.lifeTimeMaxVisits !== 'NA' ||
                          (CopaymentData?.coverageCopayments
                            ?.lifeTimeAccumVisits !== 'NA' &&
                            CopaymentData?.coverageCopayments
                              ?.lifeTimeAccumVisits > 0)) &&
                          (CopaymentData?.coverageCopayments
                            ?.lifeTimeAccumVisits !== 'NA' &&
                          CopaymentData?.coverageCopayments
                            ?.lifeTimeAccumVisits >
                            CopaymentData?.coverageCopayments
                              ?.lifeTimeMaxVisits ? (
                            <p>
                              visits lifetime{' '}
                              <b className="co-pay-limit">
                                (100%&nbsp;Visits Used)
                              </b>
                            </p>
                          ) : (
                            <span>
                              visits lifetime&nbsp;(
                              <b className="co-pay-limit">
                                {
                                  CopaymentData?.coverageCopayments
                                    ?.lifeTimeAccumVisits
                                }
                              </b>
                              &nbsp;
                              {CopaymentData?.coverageCopayments
                                ?.lifeTimeAccumVisits > 1
                                ? 'Visits Used'
                                : 'Visit Used'}
                              )
                            </span>
                          ))}
                      </Card.Text>
                    )}
                  </>
                }
              </>
            ) : (
              <Card.Text>
                Consult the Benefit Summary document for further information
              </Card.Text>
            )}
          </Card.Body>
        </Card>
      ) : (
        <Card>
          <Card.Header>
            <h5>{accumsLabel}</h5>
          </Card.Header>
          <Card.Body>
            <Card.Text>Not Covered</Card.Text>
          </Card.Body>
        </Card>
      )}
    </>
  );
};
export default CopaymentNetwork;
